import {ValidatedTextInput} from '@woocommerce/blocks-checkout';
import {useBlockProps} from '@wordpress/block-editor';
import {RichText} from '@wordpress/block-editor';
import {Button, StoreNotice} from '@woocommerce/blocks-components';

export const Edit = ({attributes, setAttributes}) => {
	const blockProps = useBlockProps();

	const {
		requestQuoteButtonLabel,
		quoteRequestedText,
		refreshLabel
	} = attributes;

	return (
		<div {...blockProps}>
			<div className={'contact-for-shipping-quote'}>
				<Button
					className='wc-block-components-checkout-request-shipping-quote-button'
				>
					<div
						className='wc-block-components-checkout-request-shipping-quote-button__text'
					>
						<RichText
							allowedFormats={[]}
							value={requestQuoteButtonLabel || ' '}
							onChange={(content) => {
								setAttributes({
									requestQuoteButtonLabel: content,
								});
							}}
						/>
					</div>
				</Button>

				<StoreNotice status="success" isDismissible={false}>
					<RichText
						style={{display: 'inline-block'}}
						allowedFormats={[]}
						value={quoteRequestedText}
						onChange={(content) => {
							setAttributes({
								quoteRequestedText: content,
							});
						}}
					></RichText>
					&nbsp;<a href="#">
					<RichText
						style={{display: 'inline-block'}}
						allowedFormats={[]}
						value={refreshLabel}
						onChange={(content) => {
							setAttributes({
								refreshLabel: content,
							});
						}}
					/>
					</a>
				</StoreNotice>

			</div>
		</div>
	)
}

export const Save = () => {
	return <div {...useBlockProps.save()}></div>;
};
